import { RESET_MY_WM_PAYMENT_INFO } from "constants-lib/actionTypes"

export const resetPaymentInfo = () => ({
  type: RESET_MY_WM_PAYMENT_INFO,
})
